module.exports = require("react-pdf");